/**
 * 乗客タイプ（area.passengerTypes。parent_id で親子を持つ行）を、親ごとのまとまりにする（純粋関数）
 *
 * - 親か子かは parent_id で決める。子の name が「親の name + '_'」で始まらない・親が見つからない行は、
 *   オプションとして扱わず1つの親にする（backend の App/Services/PassengerTypeRules と同じ考え方）
 *
 * テスト: tests/unit/passengerTypeGroups.spec.js
 */

const isOptionOf = (parent, child) => {
  if (!parent || !parent.name || !child.name) return false;
  if (parent.parent_id !== null && parent.parent_id !== undefined) return false;
  const prefix = `${parent.name}_`;
  return child.name.startsWith(prefix) && child.name.length > prefix.length;
};

/**
 * @param {Array<{id:number,name:string,label:string,parent_id:number|null}>} passengerTypes
 * @returns {{ type: object, options: object[] }[]} 親ごとのまとまり（親の並び順は元の順）
 */
export default function buildPassengerTypeGroups(passengerTypes) {
  const types = passengerTypes || [];
  const byId = new Map(types.map((t) => [Number(t.id), t]));
  const parentOf = (t) => {
    if (t.parent_id === null || t.parent_id === undefined) return null;
    const parent = byId.get(Number(t.parent_id));
    return isOptionOf(parent, t) ? parent : null;
  };

  const groups = [];
  const groupByParentId = new Map();
  types.forEach((t) => {
    if (parentOf(t)) return;
    const group = { type: t, options: [] };
    groups.push(group);
    groupByParentId.set(Number(t.id), group);
  });
  types.forEach((t) => {
    const parent = parentOf(t);
    if (parent) groupByParentId.get(Number(parent.id)).options.push(t);
  });
  return groups;
}
